import {
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { tap } from "rxjs/operators";

@Injectable()
export class URLInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (
      "/demo/scoreAndStirorShakenByClient" === this.router.url) {
      const newReq = req.clone({
        params: req.params.append("tabName", "robocall"),
      });
      return next.handle(newReq).pipe(
        // proceed when there is a response; ignore other events
        tap((event) => {
          if (event instanceof HttpResponse) {
            if (event.url.indexOf("getPointCodeVolume") != -1) {
            }
            return event;
          }
        })
      );
    } else if (
      "/demo/providerInsights" === this.router.url ||
      "/demo/industryHighRunners" === this.router.url ||
      "/demo/scoreDistribution" === this.router.url ||
      "/demo/robocallScoring" === this.router.url
    ) {
      const modifiedReq = req.clone({
        params: req.params.append("tabName", "robocall"),
        setParams: {
          carrier: "Frontier",
          termination_carrier: "Frontier",
        },
        setHeaders: {
          orgname: "Frontier",
        },
      });
      return next.handle(modifiedReq);
    } 
    return next.handle(req);
  }
}
